<template>

  <div class="content-i">
    <div class="content-box">
      <div class=" single-page-container">
        <div class="col-sm-6 col-md-3 pl-0 pr-0 middle middle">
          <ProjectInfoBlock :mainUser="''" :project="sessionInfoBlock.project" :totalProducts="0"  />
        </div>
        <div class="col-sm-9 middle">
          <div class="support-index">
            <div class="support-tickets">
              <div class="chat-head p-10">
                <div class="user-info">
                  <span class="element-wrapper">
                    <div class="element-search">
                      <input
                        :placeholder="'Add product'"
                        type="text"
                        v-on:keyup.enter="registerUpdate"
                        v-model="searchString"
                      />
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionTabs from '@/components/common/SessionView/SessionTabs'
import ProjectInfoBlock from '@/components/common/SessionView/ProjectInfoBlock'
import ProductTab from '@/components/photodesk/ViewSession/ProductTab'
import IssueTab from '@/components/photodesk/ViewSession/IssueTab'
import ProductDetails from '@/components/photodesk/ViewSession/ProductDetails'
import SessionOverview from '@/components/photodesk/ViewSession/SessionOverview'
import EmptyState from '@/components/common/EmptyState'

export default {
  name: 'session-view',
  props: ['id_project'],
  components: {
    SessionTabs,
    ProjectInfoBlock,
    ProductTab,
    IssueTab,
    ProductDetails,
    EmptyState,
    SessionOverview
  },
  mounted: function () {
    this.getSessionDetails()
  },
  data: function () {
    return {
      tabOptions: ['Products'],
      selectedTab: 'Products',
      photographer: [],
      vm: '',
      stylist: '',
      makeupartist: '',
      shootcoordinator: '',
      project: '',
      products: [],
      selectedProduct: '',
      loading: true
    }
  },
  computed: {
    productList () {
      return this.products
    },
    sessionInfoBlock () {
      return {
        mainUser: this.photographer,
        project: this.project
      }
    }
  },
  methods: {
    getSessionDetails: function () {
      var self = this
      self.$store.dispatch('updateLoading', 'true')

      const url = '/projectdesk/project/show'
      let data = {
        id_projectdesk_project: self.id_project
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.products = response.data.products
          self.photographer = response.data.photographer
          self.project = response.data.project
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('updateLoading', 'false')
        })
    },
    updateProductDetailsContainer: function (product) {
      this.selectedProduct = product
    },
    changeTab: function (tab) {
      this.selectedTab = tab
    },
    formatAvatar: function (user) {
      return 'background-image: url("http://52.66.102.131' + user.avatar + '")'
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    selectedProduct () {}
  }
}
</script>

<style>
.table th,
.table td {
  border: none;
}
.support-index {
  display: block !important;
}
</style>
